import React from 'react';

function CourseSelection({courses, onSelect, onBack, toggleChat}) {
    return (
        <>
            <div className="chat-app__head">
                <div className='chat-app__wrap'>
                    <button onClick={onBack} className="back-button">
                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M-0.165039 9.1543C-0.165039 8.93457 -0.0683594 8.73242 0.107422 8.56543L5.92578 2.75586C6.11914 2.5625 6.30371 2.49219 6.51465 2.49219C6.94531 2.49219 7.28809 2.80859 7.28809 3.24805C7.28809 3.45898 7.20898 3.66113 7.06836 3.80176L5.09961 5.80566L2.14648 8.50391L4.26465 8.37207H15.3828C15.8398 8.37207 16.1562 8.69727 16.1562 9.1543C16.1562 9.61133 15.8398 9.93652 15.3828 9.93652H4.26465L2.1377 9.80469L5.09961 12.5029L7.06836 14.5068C7.20898 14.6387 7.28809 14.8496 7.28809 15.0605C7.28809 15.5 6.94531 15.8164 6.51465 15.8164C6.30371 15.8164 6.11914 15.7373 5.94336 15.5703L0.107422 9.74316C-0.0683594 9.57617 -0.165039 9.37402 -0.165039 9.1543Z"
                                fill="#707991"/>
                        </svg>
                    </button>
                    <h2>Доступные курсы</h2>
                </div>
                {/* Кнопка закрытия чата */}
                <button onClick={toggleChat}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.75684 14.3145C3.51758 14.082 3.52441 13.6855 3.75684 13.4531L8.13184 9.07129L3.75684 4.69629C3.52441 4.46387 3.52441 4.07422 3.75684 3.83496C3.98926 3.58887 4.39258 3.5957 4.625 3.83496L9 8.20996L13.375 3.83496C13.6074 3.5957 14.0039 3.5957 14.2432 3.83496C14.4824 4.06738 14.4756 4.46387 14.2432 4.69629L9.86816 9.07129L14.2432 13.4531C14.4756 13.6855 14.4756 14.0752 14.2432 14.3145C14.0107 14.5537 13.6074 14.5469 13.375 14.3145L9 9.93945L4.625 14.3145C4.39258 14.5469 3.99609 14.5469 3.75684 14.3145Z"
                            fill="#707991"/>
                    </svg>
                </button>
            </div>
            <div className="chat-selection">
                <ul>
                    {courses.map((course) => (
                        <li className='subject__item' key={course.id} onClick={() => {
                            onSelect(course);
                        }}>
                            <img src={course.image_url} alt={course.title}/>
                            <span>{course.title}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}

export default CourseSelection;